// Trainers on your hunt (server/wayfarers.ts) went out whole each time their lead walked or began or ended a fight:
// name, outfit, level, guild and lead again, though only the spots had changed (265 KB/s at 300 players,
// 2026-10-25). One whose look is the same now goes as a name and spots (mv), six values each: name, x, y, the
// wild's species ('' when not fighting), its x and y. A page from before these gets them whole.

/** Values per trainer in mv. */
export const MV_STRIDE = 6;

/** What a walk entry carries: where the lead stands and the wild it fights. */
export interface WalkRec { n: string; x: number; y: number; w?: { s: string; x: number; y: number } }

/** A trainer's walk entry. */
export function moveEntry(r: WalkRec): (string | number)[] {
  return [r.n, r.x, r.y, r.w?.s ?? '', r.w?.x ?? 0, r.w?.y ?? 0];
}

/** The records walk entries make of those known (by name); an entry for a trainer not known is skipped. */
export function readMoves<R extends WalkRec>(mv: readonly (string | number)[], known: (n: string) => R | undefined): R[] {
  const out: R[] = [];
  for (let i = 0; i + MV_STRIDE <= mv.length; i += MV_STRIDE) {
    const was = known(String(mv[i]));
    if (!was) continue;
    const s = String(mv[i + 3]);
    const { w: _, ...rest } = was;
    out.push({ ...rest, x: Number(mv[i + 1]), y: Number(mv[i + 2]), ...(s ? { w: { s, x: Number(mv[i + 4]), y: Number(mv[i + 5]) } } : {}) } as R);
  }
  return out;
}
